import React from 'react';
import PropTypes from 'prop-types';

import ConfirmDialog from '../ConfirmDialog';

// The ticket's data-testid contract pins this exact literal (no `modal.` namespace) — the web
// verifier's Playwright selectors depend on it. Intentional deviation from CLAUDE.md rule 4. It shares
// the `remove-player-confirm-modal` root — and most of the subtree (`.message`, `.actions`,
// `.cancel-btn`, `.desktop-title`, both close affordances) — with the player-scoped
// RemovePlayerConfirmModal (Story 9); only the confirm button differs (`.confirm-btn` here vs
// `.remove-btn` there). Both live under the Profile page (List Detail is a tab inside it), so what keeps
// the ids from colliding isn't location: they're modal overlays that can't be open at once — each
// swallows the click that would open the other. The ticket pins this literal, so it's deliberate reuse.
const TESTID_PREFIX = 'remove-player-confirm-modal';
const MODAL_TITLE = 'Remove Player from List';
const CONFIRM_COPY = 'Are you sure you want to remove this player from your list? This cannot be undone.';
const REMOVE_LABEL = 'Remove';

const RemoveFromListConfirmModal = ({ isRemoving, onConfirm, onCancel }) => (
    <ConfirmDialog
        title={MODAL_TITLE}
        message={CONFIRM_COPY}
        confirmLabel={REMOVE_LABEL}
        isBusy={isRemoving}
        onConfirm={onConfirm}
        onCancel={onCancel}
        data-testid={TESTID_PREFIX}
    />
);

RemoveFromListConfirmModal.propTypes = {
    isRemoving: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

RemoveFromListConfirmModal.defaultProps = {
    isRemoving: false,
};

export default RemoveFromListConfirmModal;
